import { GALLERY } from "../data/content";
import { Reveal } from "./Reveal";

export const Gallery = () => {
  return (
    <section id="gallery" data-testid="gallery-section" className="py-16 sm:py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
        <div className="max-w-3xl">
          <Reveal>
            <p className="text-[12px] font-bold uppercase tracking-[0.22em] text-brand-teal">
              Featured Food
            </p>
          </Reveal>
          <Reveal delay={1}>
            <h2 className="mt-3 font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight text-brand-charcoal leading-[1.05]">
              Food That Looks Good,
              <br />
              Travels Well, and Feeds the Room.
            </h2>
          </Reveal>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
          {GALLERY.map((g, i) => (
            <Reveal key={g.label + i} delay={Math.min((i % 6) + 1, 6)}>
              <figure
                data-testid={`gallery-item-${i}`}
                className={`group relative overflow-hidden rounded-3xl ${
                  i % 5 === 0 ? "md:row-span-2 md:aspect-[3/5]" : "aspect-square"
                }`}
              >
                <img
                  src={g.src}
                  alt={g.label}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-charcoal/70 via-brand-charcoal/0 to-transparent opacity-90" />
                <figcaption className="absolute bottom-4 left-4 right-4 text-white">
                  <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-brand-gold">
                    Catering
                  </p>
                  <p className="mt-0.5 font-display font-bold text-[16px] sm:text-[18px] leading-tight tracking-tight">
                    {g.label}
                  </p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
